<template>
  <div class="container create-project">
    <form-wrapper
      full-footer
      full-width
    >
      <template v-slot:body>
        <div
          class="col-sm-12 col-md-6 d-flex flex-column align-items-center m-auto"
        >
          <img
            :src="require('@/assets/svg/stroke-icons.svg')"
            alt="globe"
            class="mb-1"
          >
          <h5 class="text-center mb-1 text-main">
            Create a new project
          </h5>
          <ol class="list">
            All servers within in a project share the same organization. As
            such, projects can be useful for grouping infrastructure in local
            buckets, like "Staging" from "Production" or "Apples Game" vs
            "Grapes Game." Three things:
            <li>
              You cannot move servers from one project to another once deployed.
            </li>
            <li>
              Your team members will not have the same access to all projects.
            </li>
            <li>
              If you want to create something private or with separate billing
              details, please create a new organization.
            </li>
          </ol>
          <validation-observer
            ref="projectRules"
            tag="div"
            class="w-100"
          >
            <b-form-group
              label="Project Name"
              label-for="project_name"
              class="no-icon"
            >
              <validation-provider
                #default="{ errors }"
                name="Project Name"
                rules="required"
              >
                <b-form-input
                  id="project_name"
                  v-model="new_project.project_name"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Project name"
                  @keyup.enter="validationForm"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </validation-observer>
        </div>
      </template>

      <template v-slot:footer>
        <b-button
          variant="bg-white"
          @click="
            $router.push({ name: 'project', params: { comingBack: true } })
          "
        >
          Cancel
        </b-button>
        <button-loading
          variant="bg-primary"
          type="submit"
          class="ml-16"
          :spinning="addingProject"
          @click="validationForm"
        >
          Create
        </button-loading>
      </template>
    </form-wrapper>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      organizationId: null,
      new_project: {
        project_name: '',
      },
      required,
    }
  },
  computed: {
    addingProject() {
      return this.$store.state.projects.addingProject
    },
  },
  created() {
    this.organizationId = this.$store.state.app.organizationId
    this.$store.commit('app/SET_PROJECT_ID', null)
  },
  methods: {
    validationForm() {
      this.$refs.projectRules.validate().then(success => {
        if (success) {
          const query = {
            id: this.organizationId,
            name: this.new_project.project_name,
          }
          this.$store
            .dispatch('projects/addProject', query)
            .then(res => {
              this.$store.commit('app/SET_PROJECT_ID', res.data.result.id)
              this.$store.commit('app/SET_PROJECT_NAME', res.data.result.name)
              this.$router.push({
                name: 'distributions',
                params: { projectId: res.data.result.id },
              })
              this.$store.commit('appConfig/UPDATE_NAV_MENU_HIDDEN', false)
            })
            .catch(error => {
              this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while creating project.')
            })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.create-project {
  height: 100%;
  align-items: center;
  justify-content: center;
  form {
    width: 100%;
  }
  .list {
    padding-inline-start: 0;
    margin-bottom: 40px;
    li {
      margin-left: 40px;
      margin-top: 8px;
    }
  }
  button {
    padding: 20px;
  }
}
</style>
